// Text Diff Tool — compare two blocks of text line by line.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const textDiffTool: Tool = {
  id: "text-diff",
  name: () => m.td_tool_name(),
  description: () => m.td_tool_description(),
  icon: "🔀",
  basePath: "/text-diff",
  status: "stable",
  tags: ["text", "diff", "compare", "developer"],
  pages: [
    {
      name: () => m.td_nav_main(),
      path: "/text-diff",
      description: () => m.td_nav_main_desc(),
      icon: "🔀",
    },
  ],
};
